<!--
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2020-12-21 09:49:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-17 17:10:39
 * @FilePath: \heshan_web\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import websocket from '@/util/websocket.js'
import {

  logoutDev

} from "@/api/user";
import $ from 'jquery';
import website from '@/config/website';
import {serialize} from '@/util/util';
import {getToken,getRefreshToken} from '@/util/auth';
import {
  getStore
} from '@/util/store'
export default {
  name: "app",
  data() {
    return {
      beforeUnloadTime:'',
      gapTime:''
    };
  },
  watch: {
    
  },
  computed: {

  }, 
  mounted () {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e),false)
    window.addEventListener('unload', e => this.unloadHandler(e),false)
  
  },
  beforeDestroy(){
  
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
 
  },
  created() {
    
    // localStorage.setItem("clientId",this.$store.state.user.waylist)
   
    // if(typeof(websocket.getWebSocket())=="undefined"){
      
    //     websocket.Init(this.$store.state.user.waylist)
    // }
    
  },
  methods: {
    beforeunloadHandler(e){
      
      this.beforeUnloadTime=new Date().getTime();
      // e = e || window.event
      // if(e){
      //   e.returnValue = "关闭提示"
      // }
      // return "关闭提示"
    },
    
    reportData(url, data){
      let img = document.createElement('img');
      const params = [];
      Object.keys(data).forEach((key) => {
        params.push(`${key}=${encodeURIComponent(data[key])}`);
      });
      img.onload = () => img = null;
      img.src = `${url}?${params.join('&')}`;
    },
     unloadHandler(e){
      
      this.gapTime=new Date().getTime()-this.beforeUnloadTime;
      //判断是窗口关闭还是刷新\
    
      
      if(this.gapTime<=5){
         let obj ={
            bladeAuth:`bearer ${getToken()}`,
            tenantId:`${getStore({name: 'tenantId'}) || ''}`,
            userId:getStore({name: 'userInfo'}).user_id
          } ,url="http://heshanprod.thingcom.com/api/blade-auth/oauth/logout/dev"
         const formData = new FormData()
         Object.keys(obj).forEach((key)=>{
           let value = obj[key]
           if(typeof value != 'string'){
             value = JSON.stringify(value)
           }
           formData.append(key,value)
         })
        navigator.sendBeacon(url,formData)
      
      }
    }
  },
};
</script>
<style lang="scss">
#app {
  // width: 100%;
  // height: 100%;
  // overflow: hidden;
}
</style>
